import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/servicessidebar.css";

const specialities = [
  { name: "Medicine", route: "/services/medicine" },
  { name: "Orthopedic", route: "/services/orthopedic" },
  { name: "General Surgery", route: "/services/general-surgery" },
  { name: "Pediatric", route: "/services/pediatric" },
  { name: "Urology", route: "/services/urology" },
  { name: "Gastrology", route: "/services/gastrology" },
  { name: "ENT", route: "/services/ent" },
  { name: "GI surgery", route: "/services/gi-surgery" },
  { name: "Neurology", route: "/services/neurology" },
  { name: "Critical Care", route: "/services/critical-care" },
  { name: "Trauma", route: "/services/trauma-care" },
  { name: "Joint Replacement", route: "/services/joint-replacement" },
];

const Servicessidebar = () => {
  const navigate = useNavigate();

  return (
    <div className="specialities-box">
      <div className="specialities-header">Our Specialities</div>

      <ul className="specialities-list">
        {specialities.map((item, index) => (
          <li
            key={index}
            className="speciality-item"
            onClick={() => navigate(item.route)}
          >
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Servicessidebar;
